import { FormTokenChainState } from '../../../types/context';
import { getPersistedFormTokenChain } from '../../../utils/getPersistedFormTokenChain';
import { isFormTokensDbAvailable } from '../../../utils/formTokensStorage/isFormTokensDbAvailable';
import { rehydrateFormTokensMeta } from '../../../utils/rehydrateFormTokensMeta';

export type FormTokensHydration = {
  done: boolean;
  formTokens?: FormTokenChainState;
};

// Sync gate decision: async hydration is needed only when some persisted node
// references an IndexedDB meta record
export const getInitialFormTokensHydration = (
  localStorageKey: string
): FormTokensHydration => {
  const persistedChain = getPersistedFormTokenChain(localStorageKey);
  if (!persistedChain) {
    return { done: true };
  }

  const hasMetaReferences = Object.values(persistedChain.nodes).some(
    (node) => typeof node.meta === 'string'
  );
  if (!isFormTokensDbAvailable() || !hasMetaReferences) {
    // nothing to load from IndexedDB — legacy inline meta stays, stale refs drop
    return {
      done: true,
      formTokens: rehydrateFormTokensMeta([], persistedChain),
    };
  }

  return { done: false };
};
